import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement, Fragment } from "@wordpress/element";
// @ts-nocheck

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import { Mark, MarkLabel } from './styles/range-control-styles';
export default function RangeMark(_ref) {
  let {
    className,
    isFilled = false,
    label,
    style = {},
    ...props
  } = _ref;
  const classes = classnames('components-range-control__mark', isFilled && 'is-filled', className);
  const labelClasses = classnames('components-range-control__mark-label', isFilled && 'is-filled');
  return createElement(Fragment, null, createElement(Mark, _extends({}, props, {
    "aria-hidden": "true",
    className: classes,
    isFilled: isFilled,
    style: style
  })), label && createElement(MarkLabel, {
    "aria-hidden": "true",
    className: labelClasses,
    isFilled: isFilled,
    style: style
  }, label));
}
//# sourceMappingURL=mark.js.map